import type { CashOut as BaseCashOut } from "@restaurant-staff-portal/shared";
import type { User } from "@restaurant-staff-portal/shared";

// Extended CashOut type with relations
export interface CashOutWithRelations
  extends Omit<BaseCashOut, "userId" | "approvedBy"> {
  user: Pick<User, "id" | "firstName" | "lastName" | "email">;
  approver?: Pick<User, "id" | "firstName" | "lastName" | "email">;
}

// CashOut with calculated fields from the calculation engine
export interface CashOutWithCalculations extends CashOutWithRelations {
  // True Sales calculation
  trueSales: number;

  // House Tip (8% of True Sales)
  houseTip: number;

  // Cash On Hand
  cashOnHand: number;

  // Tip-out calculations
  barTipOut: number;
  runnerTipOut: number;
  hostTipOut: number;
  kitchenTipOut: number;
  totalTipOut: number;

  // Server calculations
  chargedTips: number;
  cashSales: number;
  serverCashOwed: number;
  cashToServer: number;
  totalCheckFees: number;

  // Reconciliation
  creditCardVariance: number;
  paymentVariance: number;
  reconciledSales: boolean;
  reconciledPayments: boolean;
}

// Helper to get full name from user
export function getUserFullName(
  user: Pick<User, "firstName" | "lastName">,
): string {
  return `${user.firstName} ${user.lastName}`.trim();
}

// Helper to check if cash out is approved
export function isCashOutApproved(
  cashOut: BaseCashOut | CashOutWithRelations,
): boolean {
  return cashOut.approvedAt !== null;
}
